/** Studio-type chips on SearchPage — use `activeOption`, not `activity`. */
export const STUDIO_TYPE_ACTIVE_OPTIONS = {
  'Foto & Video Studios': 'Foto & Video Studios',
  'Musik & Aufnahme Studios': 'Musik & Aufnahme Studios',
};

export const ACTIVITY_TAG_SUGGESTIONS = [
  'Loftstudio',
  'Tageslichtstudio',
  'Fotostudio',
  'Studio',
  'Tonstudio',
  'Musikstudio',
  'Aufnahmestudio',
  'Post-Production-Studio (Mixing & Mastering)',
  'Filmstudio',
  'Videostudio',
  'Bandstudio',
  'Atelier',
  'Podcast-/Voiceover-Studio',
];

/** Shown as "Vorgeschlagen" when the activity field is empty. */
export const STUDIO_TYPE_SUGGESTIONS = [
  { id: 'studio-type-foto-video', name: 'Foto & Video Studios', searchAs: 'activeOption' },
  { id: 'studio-type-musik', name: 'Musik & Aufnahme Studios', searchAs: 'activeOption' },
];

const TAG_SUGGESTIONS = ACTIVITY_TAG_SUGGESTIONS.map((name, index) => ({
  id: `activity-tag-${index}`,
  name,
  searchAs: 'activity',
}));

/** Full suggestion list: studio types first, then tag activities. */
export const ALL_ACTIVITY_SUGGESTIONS = [...STUDIO_TYPE_SUGGESTIONS, ...TAG_SUGGESTIONS];

export const filterActivitySuggestions = (searchTerm) => {
  const term = searchTerm?.trim().toLowerCase();
  if (!term) return STUDIO_TYPE_SUGGESTIONS;

  return ALL_ACTIVITY_SUGGESTIONS.filter((item) =>
    item.name.toLowerCase().includes(term)
  );
};

export const isKnownActivitySuggestion = (name) => {
  if (!name?.trim()) return true;
  const normalized = name.trim().toLowerCase();
  return ALL_ACTIVITY_SUGGESTIONS.some(
    (item) => item.name.toLowerCase() === normalized
  );
};

/** Map selected activity label to URL search params. */
export const resolveActivitySearchParams = (activityName) => {
  const trimmed = activityName?.trim() ?? '';
  if (!trimmed) {
    return { activity: '', activeOption: 'Alle' };
  }

  if (STUDIO_TYPE_ACTIVE_OPTIONS[trimmed]) {
    return { activity: '', activeOption: STUDIO_TYPE_ACTIVE_OPTIONS[trimmed] };
  }

  return { activity: trimmed, activeOption: 'Alle' };
};

/** Append homepage search fields to URLSearchParams (activity vs activeOption). */
export const appendHomeSearchParams = (params, { activity, location, locationPlaceId, date } = {}) => {
  const { activity: activityParam, activeOption } = resolveActivitySearchParams(activity);
  const trimmedLocation = location?.trim();
  const trimmedLocationPlaceId = locationPlaceId?.trim();

  if (activityParam) params.set('activity', activityParam);
  if (activeOption && activeOption !== 'Alle') params.set('activeOption', activeOption);
  if (trimmedLocation) params.set('location', trimmedLocation);
  if (trimmedLocation && trimmedLocationPlaceId) params.set('locationPlaceId', trimmedLocationPlaceId);
  if (date?.trim()) params.set('date', date.trim());

  return params;
};

export const buildHomeSearchQueryString = (fields) =>
  appendHomeSearchParams(new URLSearchParams(), fields).toString();
